import { render, staticRenderFns } from "./TabConceptualizacion.vue?vue&type=template&id=7bf944e1&"
import script from "./TabConceptualizacion.vue?vue&type=script&lang=js&"
export * from "./TabConceptualizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports